import { useUserStore } from "@/modules/auth/store/user";
import { Avatar } from "@boringer-avatars/react";
import { TonConnectButton } from "./TonConnectButton";
import Skeleton from "@/components/common/Skeleton";
import { Button } from "@/components/common/Button";
import { handleCopyShareBotLink } from "@/modules/auth/utils/share";
import WebApp from "@twa-dev/sdk";
import { useState } from "react";
import { useTranslation } from "react-i18next";

const UserInfo = () => {
  const { t } = useTranslation();
  const { user, refcode, activated, isReferralLoading } =
    useUserStore();

  const isMiniApp = !!WebApp.initData;

  const [copied, setCopied] = useState(false);

  const handleCopy = async () => {
    const success = await handleCopyShareBotLink(refcode, isMiniApp);

    if (success) {
      setCopied(true);
      setTimeout(() => {
        setCopied(false);
      }, 3000);
    }
  };

  return (
    <div className="w-full flex items-center justify-between gap-4 px-4">
      <div className="flex items-center gap-4">
        <Avatar
          title={false}
          name={user?.id || 0}
          size={40}
          variant="beam"
          square={false}
        />

        <div className="flex flex-col py-3 gap-0.5">
          {!user?.username ? (
            <Skeleton className="w-30 h-5.5" />
          ) : (
            <p className="text-[1.0625rem] leading-[1.375rem] text-text max-w-50 truncate">
              {user?.username || "\u00A0"}
            </p>
          )}
          {!user?.username ? (
            <Skeleton className="w-20 h-5" />
          ) : (
            <p className="text-[0.9375rem] leading-[1.25rem] text-subtitle-text">
              {refcode || "\u00A0"}
            </p>
          )}
        </div>
      </div>

      {Boolean(activated === true) && (
        <Button
          onClick={handleCopy}
          text={t(copied ? "main-page.copied" : "main-page.copy")}
          size="small"
          mode={copied ? "gray" : "filled"}
          disabled={isReferralLoading}
          pilled
        />
      )}

      <TonConnectButton />
    </div>
  );
};

export default UserInfo;
